import { render, staticRenderFns } from "./DownloadInfoCard.vue?vue&type=template&id=0a4b163c&scoped=true&"
import script from "./DownloadInfoCard.vue?vue&type=script&lang=js&"
export * from "./DownloadInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./DownloadInfoCard.vue?vue&type=style&index=0&id=0a4b163c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4b163c",
  null
  
)

export default component.exports